<template>
  <div class="followup-live">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p v-if="!validated && !invalid">{{t("Please wait...")}}</p>
          <p v-if="invalid">{{t("Invalid code. Redirecting to login page...")}}</p>
          <div v-if="validated && videoId">
            <div style="padding:56.25% 0 0 0;position:relative;"><iframe :src="embedVideoPath" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fito from "@/lib/fito";
import t from "@/lib/Locale";

export default {
  name: "FollowupLive",
  data() {
    return {
      liveCode: null,
      validated: false,
      invalid: false,
      videoId: null,
    }
  },
  async mounted() {
    if (this.$route.params.code) {
      this.liveCode = this.$route.params.code
    }
    await this.validateUser()
  },
  computed: {
    embedVideoPath() {
      return `https://vimeo.com/event/${this.videoId}/embed/interaction`
    }
  },
  methods: {
    t,
    async validateUser() {
      const login = await Fito().Login.safeCheckLogin();
      let settings;
      if (login.res === "ok") {
        settings = await Fito().getLiveSettings()
        this.validated = true
        this.videoId = settings['id']
      }
      else {
        if (this.liveCode) {
          settings = await Fito().getLiveSettings()
          const res = await Fito().ValidateByLiveCode(this.liveCode)
          if (res['res'] === "ok") {
            this.validated = true
            this.videoId = settings['id']
          } else {
            this.invalid = true
            setTimeout(() => {
              this.$router.push('/plan/login?redirect=/plan/followup-live')
            }, 5000)
          }
        } else {
          this.$router.push('/plan/login?redirect=/plan/followup-live')
        }
      }
    },
  }
}
</script>